// extracted by css-extract-rspack-plugin
export default {"img":"lzp26","transition":"EX04W","loaded":"nuNVO"};